if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"file_mgmt","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(366|467|798)$/.test(chunkId)},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}